/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTradereportingV1BlueSheetEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRADEREPORTING_V1_BLUE_SHEET_EVENT_ENTITY_NAME = 'ixc.tradereporting.v1.BlueSheetEvent';
export const ixcTradereportingV1BlueSheetEventEntity = new schema.Entity<IxcTradereportingV1BlueSheetEvent>(IXC_TRADEREPORTING_V1_BLUE_SHEET_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcTradereportingV1BlueSheetEvent) => `${entity.metadata?.eventId}` });

